import b_ from 'b_';
import React from 'react';

import {TaxiFormLayoutRow} from '#components2/support/taxi-form-layout';
import {logger} from '#logger';
import i18n from 'utils/localization/i18n';

import './warning.styl';

const taxiStyle = b_.with('Warning');

interface Props {
    metaqueue: string | undefined;
    metaqueueCategory: string | undefined;
}

export const UnknownMetaqueueWarning = React.memo(function ({metaqueue, metaqueueCategory}: Props) {
    if (metaqueueCategory && metaqueueCategory !== 'unknown') {
        return null;
    }

    if (metaqueue !== 'unknown') {
        logger.error({message: 'Unknown metaqueue'}, new Error(`Unknown metaqueue: ${metaqueue || 'undefined'}`));
    }

    return (
        <TaxiFormLayoutRow gap="no">
            <div className={taxiStyle()}>{i18n.print('warning.unknown_metaqueue')}</div>
        </TaxiFormLayoutRow>
    );
});
